module.exports = __webpack_public_path__ + "static/DexExperience2-9642b63eeb4aabf68c100d982129bf68.png";